//get TeamMember
export const GET_TEAM_MEMBER = "GET_TEAM_MEMBER";

//TeamMember Details
export const TEAM_MEMBER_DETAILS = "TEAM_MEMBER_DETAILS";
export const TEAM_MEMBER_ID = "TEAM_MEMBER_ID";

//dialog type
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//insert
export const INSERT_SUBCATEGORY_MEMBER = "INSERT_SUBCATEGORY_MEMBER";

//update TeamMember
export const UPDATE_SUBCATEGORY_MEMBER = "UPDATE_SUBCATEGORY_MEMBER";

//delete TeamMember
export const DELETE_SUBCATEGORY_MEMBER = "DELETE_SUBCATEGORY_MEMBER";

//toast
export const OPEN_TEAM_MEMBER_TOAST = "OPEN_TEAM_MEMBER_TOAST";
export const CLOSE_TEAM_MEMBER_TOAST = "CLOSE_TEAM_MEMBER_TOAST";
